<section class="detalle-pedido">
	<h2>{{ newUser.nombre }}</h2>
	<br><br>
	<div *ngIf=" newVenta.tipo === 1 " [ngClass]="fnClassPedido()">
		<h3 class="estatus">Tu pedido esta {{ newVenta.estatusEnvio }}.</h3>
		<h4>Los detalles de tu pedido se indican a continuación.</h4>
	</div>
	<div *ngIf=" newVenta.tipo === 2 " [ngClass]="fnClassPedido()">
		<h3 class="estatus">Tu pedido ha sido entregado.</h3>
		<h4>Los detalles de tu pedido se indican a continuación.</h4>
	</div>
	<div *ngIf=" newVenta.tipo === 3 " [ngClass]="fnClassPedido()">
		<h3 class="estatus">Tu pedido ha sido cancelado.</h3>
		<h4>{{ newVenta.comentario }}</h4>
	</div>
	<br><br>
	<h3 class="color-blue">Detalles del pedido</h3>
	<br>
	

	<section class="detalle-peddido-cuadro">
		<section>
			<div class="multiple">
				<div class="control col3">
					<h4><b class="color-purple">Pedido </b></h4> <h4>{{ newVenta.folioCompra }}</h4>
				</div>
				<div class="control col3">
					<h4><b class="color-purple">Realizado el </b></h4> <h4>{{ newVenta.fechaCompra }}</h4>
				</div>
			</div>
			<div class="multiple">
				<div class="control col6">
					<h4><b class="color-purple">Dirección de envío </b></h4>
					<h4>{{ newVenta.direccionEnvio }}</h4>
				</div>
				<div class="control col6">
					<h4><b class="color-purple">Método de pago </b></h4>
					<h4>
						<p>{{ newVenta.tipoPago }}</p>
						<p>{{ newVenta.transaccion }}</p>
					</h4>
				</div>
			</div>
			<div class="control"  *ngIf=" newVenta.tipoVenta === 2 ">
				<h4><b class="color-purple">Sigue tu pedido </b></h4>
				<h4 (click)="fnMostrarHistorial()" class="link color-blue">{{ newVenta.guia }}</h4>
			</div>
		</section>
		<div>
			<h4><b class="color-purple">Resumen del pedido </b></h4>
			<div>
				<div class="multiple">
					<h4><b class="color-purple">Subtotal: </b></h4>
					<h4>{{ newVenta.subtotalCompra | currency:newVenta.divisa:'symbol':'.2-2' }}</h4>
				</div>
				<div class="multiple">
					<h4><b class="color-purple">Envío: </b></h4>
					<h4>{{ newVenta.envioCompra | currency:newVenta.divisa:'symbol':'.2-2' }}</h4>
				</div>
				<div class="multiple">
					<h4><b class="color-purple">Descuento: </b></h4>
					<h4>{{ newVenta.descuentoCompra | currency:newVenta.divisa:'symbol':'.2-2' }}</h4>
				</div>
				<div class="multiple">
					<h4><b class="color-purple">Impuestos: </b></h4>
					<h4>{{ newVenta.impuestoCompra | currency:newVenta.divisa:'symbol':'.2-2' }}</h4>
				</div>
				<div class="multiple">
					<h4><b class="color-purple">Total: </b></h4>
					<h4>{{ newVenta.totalCompra | currency:newVenta.divisa:'symbol':'.2-2' }}</h4>
				</div>
			</div>
		</div>
	</section>
	<div class="multiple" *ngIf=" newVenta.tipoEstatus === 1 || newVenta.tipoEstatus === 2 ">
		<div class="btn-control cancelacion">
			<button class="col3 offset9" (click)="fnMostrarCancelacion()">
				Cancelar pedido
			</button>
		</div>
	</div>

	<span class="border-purple"></span>
	<br><br>
	<section class="detalle-pedido-content">
		<div class="detalle-pedido-producto" *ngFor="let newItem of newVenta.detalle">
			<figure>
				<img [src]=" newItem.imgProducto " loading="lazy" alt="newItem.nombreProducto" />
			</figure>
			<figcaption>
				<div>{{ newItem.nombreProducto }}</div>
				<div>{{ newItem.descripcionProducto }}</div>
				<div> ({{ newItem.cantidadproducto }}) X {{ newItem.precioProducto | currency:newVenta.divisa:'symbol':'.2-2' }}</div>
			</figcaption>
		</div>
	</section>
	<br><br>
</section>




<section class="modal" *ngIf=" showModal ">
	<div class="modal-back" (click)="fnCerrarModal()"></div>
	<div class="modal-content" *ngIf=" showCancelacion ">
		<div class="modal-header">
			<h2>
				Cancelación de tu pedido {{ newVenta.folioCompra }}
				<span (click)="fnCerrarModal()"><i class="fas fa-times"></i></span>
			</h2>
		</div>
		<div class="modal-body content-cancelacion">
			<h2 class="color-purple">
				<b>Selecciona el motivo de tu cancelación</b>
			</h2>
			<div class="cancelacion-opciones">
				<div (click)="fnSeleccionMotivo( newItem )" *ngFor="let newItem of listaMotivos" [ngClass]="{ 'active':newItem.seleccionado }">
					<span> {{ newItem.descripcion }} </span>
				</div>
			</div>
			<div class="multiple">
				<div class="btn-control">
					<button class="col3 offset9 fondo-blue" (click)="fnEnviarCancelacion()">
						Enviar
					</button>
				</div>
			</div>
		</div>
	</div>
	<div class="modal-content" *ngIf=" showHistorial ">
		<div class="modal-header">
			<h2>
				Historial de movimiento del pedido {{ newVenta.folioCompra }}
				<span (click)="fnCerrarModal()"><i class="fas fa-times"></i></span>
			</h2>
		</div>
		<div class="modal-body">
			<div class="multiple">
				<div class="control col6">
					<h3 class="color-purple">Fecha de entrega estimada</h3>
					<h4 class="color-blue">{{ ultimoMovimiento.fechaEstimada1 }} - {{ ultimoMovimiento.fechaEstimada2 }}</h4>
				</div>
				<div class="control col6">
					<h3 class="color-purple">Ultimo Estatus</h3>
					<h4 class="color-blue">{{ ultimoMovimiento.estatus }}</h4>
				</div>	
			</div>
			<div class="table-responsive">
				<table class="table table-hover">
					<thead>
						<tr>
							<th>Fecha</th>
							<th>Comentario</th>
						</tr>
					</thead>
					<tbody>
						<tr *ngFor="let newItem of newVenta.historialEnvio | reverse; let i = index">
							<td>{{ newItem.creacion }}</td>
							<td>{{ newItem.descripcion }}</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
	</div>
</section>

<style type="text/css">

	.content-cancelacion > h2{
		width: 100%;
		text-align: center;
	}
	.content-cancelacion button{
		border-radius: 100px;
	    padding: 10px;
	    color: white;
	    max-width: 100%;
	    height: 50px;
	    font-size: 1.2rem;
	    border: transparent;
	}
	.content-cancelacion .multiple{
		width: 80%;
		margin: auto;
	}
	.cancelacion-opciones{
		width: 80%;
		display: grid;
	  	grid-template-columns: repeat(2, 1fr);
	  	grid-gap: 15px;
	  	margin: 20px auto;
	}
	.cancelacion-opciones > div{
		height: 40px;
		display: flex;
		align-items: center;
		padding: 0px 10px;

		color: black;
	    background-color: transparent;
	    border: #28a745 solid 1px;
	    border-radius: .50rem;
	}
	.cancelacion-opciones > div > span{
		display: block;
		width: 100%;
		color: black;
		text-align: center;
	}
	.cancelacion-opciones > div:hover{
		background-color: #d4edda;
		cursor: pointer;
	}
	.cancelacion-opciones > div:hover > span{
		color: black;
	}
	.cancelacion-opciones > div.active{
    	background-color: #28a745;;
    	border: #28a745 solid 1px;
	}
	.cancelacion-opciones > div.active > span{
		display: block;
		width: 100%;
		text-align: center;
		color: white;
	}


	.cancelacion{
		margin: 0px;
		margin-bottom: 10px;
	}
	.cancelacion > button{
		background-color: red;
		color: white;
		font-size: 1.2rem;
		padding: 10px 20px;
		font-family: helvetica-bold;
	}
	.modal{
		position: fixed;
		top: 0px;
		left: 0px;
		width: 100%;
		height: 100%;
		display: flex;
		align-items: center;
		z-index: 100;
	}
	.modal-back{
		position: absolute;
		top: 0px;
		left: 0px;
		width: 100%;
		height: 100%;
		background-color: rgba(0,0,0,0.8);
	}
	.modal-content{
		position: absolute;
		width: 90%;
		top: 8%;
		left: 5%;
		z-index: 200;
		background-color: white;
	}
	.modal-header{
		width: 100%;
		height: auto;
		display: flex;
		align-items: center;
		padding: 0px 10px;
	}
	.modal-header > h2{
		width: 100%;
		font-family: helvetica-bold;
		position: relative;
	}
	.modal-header > h2 > span{
		position: absolute;
		right: 0px;
		cursor: pointer;
	}
	.modal-body{
		width: 100%;
		padding: 15px;
		border-top: #bbb solid 1px;
		border-bottom: #bbb solid 1px;
	}
	.multiple{
		display: block;
	}
	.multiple > div{
		width: 100%;
	}
	.table-responsive{
		height: 300px;
    	overflow-y: scroll !important;
	}
	@media only screen and (min-width: 500px) and (max-width: 1023px) {
		.modal-content{
			width: 80%;
			left: 10%;
			top: 15%;
		}
		.modal-header{
			height: 40px;
		}
	}
	@media only screen and (min-width: 1024px){
		.modal-content{
			width: 70%;
			left: 15%;
			top: 15%;
		}
		.modal-header{
			height: 40px;
		}
	}




table {
  border-collapse: collapse;
  border-spacing: 0;
}
td,
th {
  padding: 0;
}

table {
  background-color: transparent;
}
table col[class*="col-"] {
  position: static;
  display: table-column;
  float: none;
}
table td[class*="col-"],
table th[class*="col-"] {
  position: static;
  display: table-cell;
  float: none;
}
th {
  text-align: left;
}
.table {
  width: 100%;
  max-width: 100%;
  margin-bottom: 20px;
}
.table > thead > tr > th,
.table > tbody > tr > th,
.table > tfoot > tr > th,
.table > thead > tr > td,
.table > tbody > tr > td,
.table > tfoot > tr > td {
  padding: 8px;
  line-height: 1.42857143;
  vertical-align: top;
  border-top: 1px solid #dddddd;
}
.table > thead > tr > th {
  vertical-align: bottom;
  border-bottom: 2px solid #dddddd;
}
.table > caption + thead > tr:first-child > th,
.table > colgroup + thead > tr:first-child > th,
.table > thead:first-child > tr:first-child > th,
.table > caption + thead > tr:first-child > td,
.table > colgroup + thead > tr:first-child > td,
.table > thead:first-child > tr:first-child > td {
  border-top: 0;
}
.table > tbody + tbody {
  border-top: 2px solid #dddddd;
}
.table .table {
  background-color: #ffffff;
}
.table-condensed > thead > tr > th,
.table-condensed > tbody > tr > th,
.table-condensed > tfoot > tr > th,
.table-condensed > thead > tr > td,
.table-condensed > tbody > tr > td,
.table-condensed > tfoot > tr > td {
  padding: 5px;
}
.table-bordered {
  border: 1px solid #dddddd;
}
.table-bordered > thead > tr > th,
.table-bordered > tbody > tr > th,
.table-bordered > tfoot > tr > th,
.table-bordered > thead > tr > td,
.table-bordered > tbody > tr > td,
.table-bordered > tfoot > tr > td {
  border: 1px solid #dddddd;
}
.table-bordered > thead > tr > th,
.table-bordered > thead > tr > td {
  border-bottom-width: 2px;
}
.table-striped > tbody > tr:nth-of-type(odd) {
  background-color: #f9f9f9;
}
.table-hover > tbody > tr:hover {
  background-color: #f5f5f5;
}
.table > thead > tr > td.active,
.table > tbody > tr > td.active,
.table > tfoot > tr > td.active,
.table > thead > tr > th.active,
.table > tbody > tr > th.active,
.table > tfoot > tr > th.active,
.table > thead > tr.active > td,
.table > tbody > tr.active > td,
.table > tfoot > tr.active > td,
.table > thead > tr.active > th,
.table > tbody > tr.active > th,
.table > tfoot > tr.active > th {
  background-color: #f5f5f5;
}
.table-hover > tbody > tr > td.active:hover,
.table-hover > tbody > tr > th.active:hover,
.table-hover > tbody > tr.active:hover > td,
.table-hover > tbody > tr:hover > .active,
.table-hover > tbody > tr.active:hover > th {
  background-color: #e8e8e8;
}
.table > thead > tr > td.success,
.table > tbody > tr > td.success,
.table > tfoot > tr > td.success,
.table > thead > tr > th.success,
.table > tbody > tr > th.success,
.table > tfoot > tr > th.success,
.table > thead > tr.success > td,
.table > tbody > tr.success > td,
.table > tfoot > tr.success > td,
.table > thead > tr.success > th,
.table > tbody > tr.success > th,
.table > tfoot > tr.success > th {
  background-color: #dff0d8;
}
.table-hover > tbody > tr > td.success:hover,
.table-hover > tbody > tr > th.success:hover,
.table-hover > tbody > tr.success:hover > td,
.table-hover > tbody > tr:hover > .success,
.table-hover > tbody > tr.success:hover > th {
  background-color: #d0e9c6;
}
.table > thead > tr > td.info,
.table > tbody > tr > td.info,
.table > tfoot > tr > td.info,
.table > thead > tr > th.info,
.table > tbody > tr > th.info,
.table > tfoot > tr > th.info,
.table > thead > tr.info > td,
.table > tbody > tr.info > td,
.table > tfoot > tr.info > td,
.table > thead > tr.info > th,
.table > tbody > tr.info > th,
.table > tfoot > tr.info > th {
  background-color: #d9edf7;
}
.table-hover > tbody > tr > td.info:hover,
.table-hover > tbody > tr > th.info:hover,
.table-hover > tbody > tr.info:hover > td,
.table-hover > tbody > tr:hover > .info,
.table-hover > tbody > tr.info:hover > th {
  background-color: #c4e3f3;
}
.table > thead > tr > td.warning,
.table > tbody > tr > td.warning,
.table > tfoot > tr > td.warning,
.table > thead > tr > th.warning,
.table > tbody > tr > th.warning,
.table > tfoot > tr > th.warning,
.table > thead > tr.warning > td,
.table > tbody > tr.warning > td,
.table > tfoot > tr.warning > td,
.table > thead > tr.warning > th,
.table > tbody > tr.warning > th,
.table > tfoot > tr.warning > th {
  background-color: #fcf8e3;
}
.table-hover > tbody > tr > td.warning:hover,
.table-hover > tbody > tr > th.warning:hover,
.table-hover > tbody > tr.warning:hover > td,
.table-hover > tbody > tr:hover > .warning,
.table-hover > tbody > tr.warning:hover > th {
  background-color: #faf2cc;
}
.table > thead > tr > td.danger,
.table > tbody > tr > td.danger,
.table > tfoot > tr > td.danger,
.table > thead > tr > th.danger,
.table > tbody > tr > th.danger,
.table > tfoot > tr > th.danger,
.table > thead > tr.danger > td,
.table > tbody > tr.danger > td,
.table > tfoot > tr.danger > td,
.table > thead > tr.danger > th,
.table > tbody > tr.danger > th,
.table > tfoot > tr.danger > th {
  background-color: #f2dede;
}
.table-hover > tbody > tr > td.danger:hover,
.table-hover > tbody > tr > th.danger:hover,
.table-hover > tbody > tr.danger:hover > td,
.table-hover > tbody > tr:hover > .danger,
.table-hover > tbody > tr.danger:hover > th {
  background-color: #ebcccc;
}
.table-responsive {
  min-height: .01%;
  overflow-x: auto;
}
@media screen and (max-width: 767px) {
  .table-responsive {
    width: 100%;
    margin-bottom: 15px;
    overflow-y: hidden;
    -ms-overflow-style: -ms-autohiding-scrollbar;
    border: 1px solid #dddddd;
  }
  .table-responsive > .table {
    margin-bottom: 0;
  }
  .table-responsive > .table > thead > tr > th,
  .table-responsive > .table > tbody > tr > th,
  .table-responsive > .table > tfoot > tr > th,
  .table-responsive > .table > thead > tr > td,
  .table-responsive > .table > tbody > tr > td,
  .table-responsive > .table > tfoot > tr > td {
    white-space: nowrap;
  }
  .table-responsive > .table-bordered {
    border: 0;
  }
  .table-responsive > .table-bordered > thead > tr > th:first-child,
  .table-responsive > .table-bordered > tbody > tr > th:first-child,
  .table-responsive > .table-bordered > tfoot > tr > th:first-child,
  .table-responsive > .table-bordered > thead > tr > td:first-child,
  .table-responsive > .table-bordered > tbody > tr > td:first-child,
  .table-responsive > .table-bordered > tfoot > tr > td:first-child {
    border-left: 0;
  }
  .table-responsive > .table-bordered > thead > tr > th:last-child,
  .table-responsive > .table-bordered > tbody > tr > th:last-child,
  .table-responsive > .table-bordered > tfoot > tr > th:last-child,
  .table-responsive > .table-bordered > thead > tr > td:last-child,
  .table-responsive > .table-bordered > tbody > tr > td:last-child,
  .table-responsive > .table-bordered > tfoot > tr > td:last-child {
    border-right: 0;
  }
  .table-responsive > .table-bordered > tbody > tr:last-child > th,
  .table-responsive > .table-bordered > tfoot > tr:last-child > th,
  .table-responsive > .table-bordered > tbody > tr:last-child > td,
  .table-responsive > .table-bordered > tfoot > tr:last-child > td {
    border-bottom: 0;
  }
}
</style>




